import { Skeleton } from "@chakra-ui/react";

export const PlayerCardSkeleton = () => <Skeleton />;
